(function () {
  if (window.freejoyProductMediaLikeLoaded) return;
  window.freejoyProductMediaLikeLoaded = true;

  function visibleArea(element) {
    const rect = element.getBoundingClientRect();
    if (rect.width < 180 || rect.height < 180) return 0;
    const styles = getComputedStyle(element);
    if (styles.display === 'none' || styles.visibility === 'hidden') return 0;
    return rect.width * rect.height;
  }

  function findVisibleMediaTarget(wrapper) {
    const section = wrapper.closest('.shopify-section') || document;
    const images = Array.from(new Set(section.querySelectorAll('media-gallery img, .product-media-container img')));
    const image = images.find((candidate) => visibleArea(candidate) > 0);
    return image?.closest('.product-media-container, slideshow-slide, [data-product-media]') || null;
  }

  function positionLike(wrapper, attempt = 0) {
    const target = findVisibleMediaTarget(wrapper);
    if (target) {
      target.classList.add('freejoy-main-media-like-target');
      target.appendChild(wrapper);
      wrapper.dataset.freejoyMediaLikeInitialized = 'true';
      return;
    }
    if (attempt < 20) requestAnimationFrame(() => positionLike(wrapper, attempt + 1));
  }

  function initialize(root = document) {
    root.querySelectorAll('[data-freejoy-main-media-like]').forEach((wrapper) => {
      if (wrapper.dataset.freejoyMediaLikeInitialized === 'true') return;
      positionLike(wrapper);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  let resizeTimer;
  window.addEventListener('resize', () => { clearTimeout(resizeTimer); resizeTimer = setTimeout(() => document.querySelectorAll('[data-freejoy-main-media-like]').forEach(wrapper => positionLike(wrapper)), 150); });
  window.addEventListener('load', () => initialize(), { once: true });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:block:select', (event) => initialize(event.target));
})();

